import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import FJAIPhotoEditorPrompt from '../view/FJAIPhotoEditorPrompt';
import FJActionAIPhotoEditor from '../../../../redux/action/FJActionAIPhotoEditor';

const FJAIPhotoEditorPromptContainer = () => {
    const dispatch = useDispatch();

    const promptSlateNodes = useSelector(state => state.aiPhotoEditor.promptSlateNodes);
    const promptMaxLength = useSelector(state => state.aiPhotoEditor.promptMaxLength);
    const promptStatus = useSelector(state => state.aiPhotoEditor.promptStatus);

    const handlePromptChange = useCallback(
        value => {
            dispatch(FJActionAIPhotoEditor.setPromptSlateNodesAction(value));
        },
        [dispatch],
    );

    const handleImprovePrompts = useCallback(() => {
        dispatch(FJActionAIPhotoEditor.improvePromptsAction());
    }, [dispatch]);

    const handleCancel = useCallback(() => {
        dispatch(FJActionAIPhotoEditor.cancelImprovePromptsAction());
    }, [dispatch]);

    return (
        <FJAIPhotoEditorPrompt
            value={promptSlateNodes}
            onChange={handlePromptChange}
            maxLength={promptMaxLength}
            onClickImprovePrompts={handleImprovePrompts}
            promptStatus={promptStatus}
            onCancel={handleCancel}
        />
    );
};

export default FJAIPhotoEditorPromptContainer;
